import { Component, Injectable, ViewChild } from '@angular/core';
import { ModalComponent, ModalConfig } from '../modal/modal.component'


@Component({
  selector: 'json-viewer',
  styleUrls: ['./json-viewer.component.scss'],
  templateUrl: "./json-viewer.component.html"
})

export class JsonViewerComponent implements ModalConfig {
  public data: string;
  public modalTitle = "Visualizador";
  public closeButtonLabel = "Fechar";
  public jsonString;
  public jsonObject = {};
  public text = "";
  public isJson = true;

  @ViewChild('modal', { static: true }) private modalComponent: ModalComponent
  constructor() {


  }

  public hideDismissButton() {
    return true;
  }

  async abrir(title, text, isJson) {
    this.isJson = isJson;
    this.modalTitle = title;
    this.jsonString = text;

    if (isJson) {
      this.jsonObject = JSON.parse(this.jsonString);
    }
    await this.modalComponent.open();
  }

  async fechar() {
    await this.modalComponent.close();

  }


}
